import React from "react";
import Pagination from "./Pagination";

const Table = ({
  data,
  headerFields,
  handlePageChange,
  currentPage,
  totalPages,
  itemsPerPage,
  onRowClick,
}) => {
  const statusColors = {
    approved: "text-green-500",
    resolved: "text-green-500",
    rejected: "text-red-500",
    pending: "text-orange-500",
  };

  return (
    <>
      {data?.length === 0 ? (
        <main className="h-[calc(100vh-66.5vh)] w-full flex items-center justify-center">
          <div className="ml-2 text-lg">No records found!</div>
        </main>
      ) : (
        <main className="h-full overflow-scroll no-scrollbar">
          <table className="w-full h-full border border-gray-200 bg-white rounded-lg shadow-md overflow-hidden mt-4">
            <thead className="bg-gray-100">
              <tr>
                {headerFields.map((heading, index) => (
                  <th
                    key={index}
                    className="p-3 text-left text-gray-700 font-medium text-sm border-b"
                  >
                    {heading.label}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody className="w-full">
              {data?.map((row, index) => {
                const serialNumber =
                  (currentPage - 1) * itemsPerPage + index + 1;

                return (
                  <tr
                    key={row._id}
                    className="hover:bg-gray-50 transition cursor-pointer"
                    onClick={() => onRowClick(row)}
                  >
                    {headerFields.map((field, idx) => {
                      let cellValue = row[field.backendField];
                      // console.log("cellValue - ", cellValue);

                      if (field.backendField === "warrStatus") {
                        cellValue = (
                          <td
                            className={`p-3 text-sm font-semibold ${
                              statusColors[cellValue?.toLowerCase()] ||
                              "text-orange-500"
                            }`}
                          >
                            {cellValue}
                          </td>
                        );
                      } else if (field.backendField === "purchaseDate") {
                        cellValue = cellValue
                          ? new Date(cellValue).toISOString().split("T")[0]
                          : "";
                      } else if (field.backendField === "images") {
                        cellValue =
                          row.images && Array.isArray(row.images)
                            ? row.images.map((img, imgIndex) => (
                                <img
                                  key={imgIndex}
                                  src={img.url}
                                  alt={img.name}
                                  className="w-16 h-16"
                                />
                              ))
                            : "No Images";
                      } else if (field.backendField === "natureOfIssue") {
                        cellValue = (
                          <td className="p-3 text-sm text-gray-600">
                            {cellValue !== "Others"
                              ? cellValue
                              : cellValue + ` (` + row.otherIssue + `)`}
                          </td>
                        );
                      }

                      return (
                        <td key={idx} className="p-3 text-sm text-gray-600">
                          {field.backendField === "serialNumber"
                            ? serialNumber
                            : field.backendField === "name"
                            ? row.warrantyFormID?.name || row?.name
                            : cellValue}
                        </td>
                      );
                    })}
                  </tr>
                );
              })}
            </tbody>
          </table>
          {data?.length === 0 ? null : (
            <Pagination
              handlePageChange={handlePageChange}
              currentPage={currentPage}
              totalPages={totalPages}
            />
          )}
        </main>
      )}
    </>
  );
};

export default Table;

// import React from "react";
// import Pagination from "./Pagination";
// import { ArrRefresh2O } from "lovedicons/dist/arrO";

// const Table = ({
//   data,
//   headerFields,
//   handlePageChange,
//   currentPage,
//   totalPages,
//   itemsPerPage,
//   onRowClick,
// }) => {
//   const statusColors = {
//     approved: "text-green-400",
//     rejected: "text-red-500",
//     pending: "text-orange-500",
//   };

//   return (
//     <>
//       {data.length === 0 ? (
//         <div className="w-full h-[355px] flex items-center justify-center">
//           <div>
//             <ArrRefresh2O className="w-5 h-5 animate-spin" />
//           </div>
//           <div className="ml-2"> Fetching warranties!</div>
//         </div>
//       ) : (
//         <main className="h-full overflow-scroll">
//           <table className="w-full h-full border border-gray-200 bg-white rounded-lg shadow-md overflow-hidden mt-4">
//             <thead className="bg-gray-100">
//               <tr>
//                 {headerFields.map((heading, index) => (
//                   <th
//                     key={index}
//                     className="p-3 text-left text-gray-700 font-medium text-sm border-b"
//                   >
//                     {heading}
//                   </th>
//                 ))}
//               </tr>
//             </thead>
//             <tbody className="w-full">
//               {data?.map((row, index) => {
//                 const serialNumber =
//                   (currentPage - 1) * itemsPerPage + index + 1;
//                 const {
//                   _id,
//                   name,
//                   email,
//                   phone,
//                   // useCase,
//                   // ageGroup,
//                   wowNo,
//                   frameNo,
//                   warrStatus,
//                   purchaseDate,
//                   // pincode,
//                   // state,
//                   // city,
//                   // brand,
//                   // sourceOfPurchase,
//                 } = row;
//                 return (
//                   <tr
//                     key={_id}
//                     className="hover:bg-gray-50 transition"
//                     onClick={() => onRowClick(row)}
//                   >
//                     <td className="p-3 border-b text-sm text-gray-600">
//                       {serialNumber}
//                     </td>
//                     <td className="p-3 border-b text-sm text-gray-600">
//                       {name}
//                     </td>
//                     <td className="p-3 border-b text-sm text-gray-600">
//                       {email}
//                     </td>
//                     <td className="p-3 border-b text-sm text-gray-600">
//                       {phone}
//                     </td>
//                     <td className="p-3 border-b text-sm text-gray-600">
//                       {wowNo}
//                     </td>
//                     <td className="p-3 border-b text-sm text-gray-600">
//                       {frameNo}
//                     </td>
//                     {/* statusColors[warrStatus?.toLowerCase()] || "text-gray-500"; */}
//                     <td
//                       className={`p-3 border-b text-sm font-semibold ${
//                         statusColors[warrStatus?.toLowerCase()]
//                       }`}
//                     >
//                       {warrStatus}
//                     </td>
//                     <td className="p-3 border-b text-sm text-gray-600">
//                       {purchaseDate
//                         ? new Date(purchaseDate).toISOString().split("T")[0]
//                         : ""}
//                     </td>
//                   </tr>
//                 );
//               })}
//             </tbody>
//           </table>
//           <Pagination
//             handlePageChange={handlePageChange}
//             currentPage={currentPage}
//             totalPages={totalPages}
//           />
//         </main>
//       )}
//     </>
//   );
// };

// export default Table;
